import { render, staticRenderFns } from "./tongzhi.vue?vue&type=template&id=a0278edc&scoped=true&"
import script from "./tongzhi.vue?vue&type=script&lang=js&"
export * from "./tongzhi.vue?vue&type=script&lang=js&"
import style0 from "./tongzhi.vue?vue&type=style&index=0&id=a0278edc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0278edc",
  null
  
)

export default component.exports